import { tracking as barkTrackingLogEvent } from '@bark/bark-core';

export default function () {
	const { bugsnagClient } = window;
	const { api } = window.Bark;

	const state = {
		expName: 'archived_sub_status',
		responseYes: 'replied',
		responseNo: 'no-reply',
		responseDismiss: 'no-status',
		projectResponseStatusId: '',
		projectResponseId: '',
		statusId: '',
		successCallback: null,
	};

	const domElements = {
		modalId: 'response-status-feedback-modal',
	};

	const init = (data, successCallback) => {
		if (data?.data?.project_response_status_id) {
			state.projectResponseId = data?.project_response_id;
			state.projectResponseStatusId = data.data.project_response_status_id;
			state.statusId = data?.status_id;
			state.successCallback = successCallback;
			bindListeners();
			$(`#${domElements.modalId}`).modal('show');
		}
	};

	const createFeedback = (feedbackValue) => {
		api(
			'seller/response-status-feedback',
			{
				project_response_status_id: state.projectResponseStatusId,
				feedback_value: feedbackValue,
			},
			(res) => {
				state.projectResponseId = '';
				state.projectResponseStatusId = '';
				state.successCallback && state.statusId && state.successCallback(state.statusId);
			},
			(error) => {
				state.projectResponseId = '';
				state.projectResponseStatusId = '';
				bugsnagClient.notify(new Error('Failed to create response status feedback'), {
					metaData: error,
				});
			},
			'POST',
		);
	};

	const bindListeners = () => {
		$('.js-rsfb-yes-btn')
			.off('click')
			.on('click', function (e) {
				e.preventDefault();

				barkTrackingLogEvent(
					'seller-leads-dashboard-&-responses',
					'archived_sub_status - modal response',
					{
						status: `archived - ${state.responseYes}`,
						project_response_id: state.projectResponseId,
						project_response_status_id: state.projectResponseStatusId,
					},
				);

				createFeedback(state.responseYes);

				$(`#${domElements.modalId}`).modal('hide');
			});

		$('.js-rsfb-no-btn')
			.off('click')
			.on('click', function (e) {
				e.preventDefault();

				barkTrackingLogEvent(
					'seller-leads-dashboard-&-responses',
					'archived_sub_status - modal response',
					{
						status: `archived - ${state.responseNo}`,
						project_response_id: state.projectResponseId,
						project_response_status_id: state.projectResponseStatusId,
					},
				);

				createFeedback(state.responseNo);

				$(`#${domElements.modalId}`).modal('hide');
			});

		$('.js-rsfb-dismiss-btn')
			.off('click')
			.on('click', function (e) {
				e.preventDefault();

				barkTrackingLogEvent(
					'seller-leads-dashboard-&-responses',
					'archived_sub_status - modal response',
					{
						status: `archived - ${state.responseDismiss}`,
						project_response_id: state.projectResponseId,
						project_response_status_id: state.projectResponseStatusId,
					},
				);

				createFeedback(state.responseDismiss);

				$(`#${domElements.modalId}`).modal('hide');
			});
	};

	return {
		init,
	};
}
